import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { View } from 'react-native';
import { Avatar, Typography, BLACK_100, getTestId } from '@airtel/air-design-system';
import { getSectionHeaderStyles } from './SectionHeaderStyles';
export var SectionHeader = props => {
  var testID = props.testID,
    _props$avatarProps = props.avatarProps,
    avatarProps = _props$avatarProps === void 0 ? {} : _props$avatarProps,
    _props$titleProps = props.titleProps,
    titleProps = _props$titleProps === void 0 ? {} : _props$titleProps,
    _props$sectionHeaderS = props.sectionHeaderStyle,
    sectionHeaderStyle = _props$sectionHeaderS === void 0 ? {} : _props$sectionHeaderS;
  var sectionHeaderStyles = getSectionHeaderStyles();
  return _jsxs(View, Object.assign({
    style: [sectionHeaderStyles.container, sectionHeaderStyle]
  }, {
    children: [_jsx(Avatar, Object.assign({
      variant: "image",
      style: sectionHeaderStyles.avatarStyle,
      imageResizeMode: "cover",
      outerContainerStyles: sectionHeaderStyles.avatarContainer
    }, avatarProps, getTestId(testID, 'AvatarWidget'))), _jsx(Typography, Object.assign({
      type: "body-para-xl-bold",
      color: BLACK_100,
      numberOfLines: 2,
      style: sectionHeaderStyles.sectionHeaderTitle
    }, titleProps, getTestId(testID, 'TypographyWidget')))]
  }));
};